module.exports = __webpack_public_path__ + "76cf20cf8f8fa9ce098e772e0ce63ae0.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-92.png
// module id = 153
// module chunks = 0